module.exports = __webpack_public_path__ + "static/fonts/iconfont.45a03cce.eot";